import { render, staticRenderFns } from "./KsButtonGroup.vue?vue&type=template&id=913064b6"
import script from "./KsButtonGroup.vue?vue&type=script&lang=js"
export * from "./KsButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports